import React from 'react';
import { motion } from 'framer-motion';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <motion.div
      className="loading-screen"
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: 'easeInOut' }}
    >
      <div className="loading-content">
        <motion.div
          className="loading-logo-wrapper"
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ duration: 1.2, ease: [0.34, 1.56, 0.64, 1] }}
        >
          <img src="/logo-cropped.png" alt="Cory Blossom" className="loading-logo" />
        </motion.div>

        <motion.div
          className="loading-text"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          <span className="loading-tagline">Fresh flowers, grown with love</span>
        </motion.div>

        <motion.div
          className="loading-bar-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.4 }}
        >
          <motion.div
            className="loading-bar"
            initial={{ width: 0 }}
            animate={{ width: '100%' }}
            transition={{ delay: 1.4, duration: 1.2, ease: 'easeInOut' }}
          />
        </motion.div>
      </div>

      <div className="loading-petals">
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={i}
            className="loading-petal"
            initial={{
              x: Math.random() * window.innerWidth,
              y: -50,
              rotate: 0,
              opacity: 0,
            }}
            animate={{
              y: window.innerHeight + 50,
              rotate: 360 * (Math.random() > 0.5 ? 1 : -1),
              opacity: [0, 1, 1, 0],
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              delay: Math.random() * 1.5,
              ease: 'easeIn',
            }}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
